import { Component, OnInit, Input } from '@angular/core';
import { KnowledgeService } from '../../../service/knowledge.service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { NzModalService, NzModalRef } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadChangeParam, NzUploadFile } from 'ng-zorro-antd/upload';

@Component({
  selector: 'app-knowledge-detail',
  templateUrl: './knowledge-detail.component.html',
  styleUrls: ['./knowledge-detail.component.less']
})
export class KnowledgeDetailComponent implements OnInit {

  @Input() knowledgeTypes: any;
  @Input() kno: string | undefined;
  @Input() info: any;
  @Input() canSave: boolean | undefined; // false表示详情，true表示修改
  @Input() jobInfo: any;
  // canSave = false;
  validateForm: FormGroup | undefined;
  uploadFileList: any[] = [];
  filePathList: any[] = [];
  fileType = ['image/png', 'image/jpeg', 'image/gif', 'image/bmp', 'img'];
  uploading = false;
  constructor(
    private fb: FormBuilder,
    private modalRef: NzModalRef,
    private modal: NzModalService,
    public message: NzMessageService,
    public daService: KnowledgeService
  ) {

  }

  ngOnInit(): void {
    // if (this.kno != null && this.kno !== undefined)
    if (this.canSave) {
      this.validateForm = this.fb.group({
        kname: new FormControl({ value: null, disabled: true }, Validators.required),
        ktNo: new FormControl({ value: null, disabled: true }, Validators.required),
        responser: new FormControl({ value: null, disabled: true }),
        desc: new FormControl({ value: null, disabled: true }, [Validators.maxLength(100)]),
      });
    } else {
      this.validateForm = this.fb.group({
        kname: new FormControl({ value: '', disabled: false }, Validators.required),
        ktNo: new FormControl({ value: '', disabled: false }, Validators.required),
        responser: new FormControl({ value: '', disabled: false }),
        desc: new FormControl({ value: null, disabled: false }, [Validators.maxLength(200)]),
      });
    }
    if (this.kno != null && this.kno !== undefined) {
      this.validateForm.setValue({ kname: this.info.kname, ktNo: this.info.ktNo, responser: this.info.responser, desc: this.info.desc });
      this.queryAttachment();
    }
    if (this.jobInfo != null && this.jobInfo !== undefined) {
      this.validateForm.setValue({ kname: this.jobInfo.name, ktNo: '', responser: this.jobInfo.zrr, desc: this.jobInfo.desc });
      this.uploadFileList = this.jobInfo.fileList;
    }

  }


  async queryAttachment() {
    if(this.kno == undefined){
      return 
    }
    const result = await this.daService.queryKnowledgeAttachment(this.kno);
    const fList: any[] = [];
    if (result.code !== 200) {
      this.message.create('error', result.msg);
      return;
    } else {
      result.data.forEach((element: any) => {
        let fileNode = new FileNode();
        fileNode = {
          uid: element.id,
          name: element.attachName,
          url: 'attachmentServer' + element.url,
          status: 'done',
          showDownload: false,
          type: element.attachType,
          response: { code: 200, data: { url: element.url } },
          iconType: '',
          isImageUrl: false,
          isUploading: false,
          linkProps: undefined,
          message: ''
        };
        fList.push(fileNode);
      });
    }
    this.uploadFileList = fList;
  }

  async  handleChange({ file, fileList }: NzUploadChangeParam) {
    if (file.status === 'uploading') {
      return;
    }
    let fList = fileList;
    fList = fList.slice(-9);
    fList = fList.map(fe => {
      if (fe.response.code === 200) {
        // Component will show file.url as link
        fe.url = 'attachmentServer' + fe.response.data.url;
      }
      return fe;
    });
    this.uploadFileList = fList;
    console.log(this.uploadFileList);
  }

  removeFile = (file: NzUploadFile) => {
    if (this.canSave) {
      return false;
    } else {
      return true;
    }
  }

  cancleKnowledgeData() {
    this.modalRef.destroy('cancle');
  }

  async saveKnowledgeData() {
    if(this.validateForm == undefined){
      return ;
    }
    if (this.validateForm.value.kname == null || this.validateForm.value.kname === undefined
      || this.validateForm.value.kname.toString() === '') {
      this.message.create('warning', '请输入知识名称!');
      return;
    }
    if (this.validateForm.value.ktNo == null || this.validateForm.value.ktNo === undefined
      || this.validateForm.value.ktNo.toString() === '') {
      this.message.create('warning', '请选择知识类型!');
      return;
    }
    if (this.validateForm.value.desc != null && this.validateForm.value.desc.length > 200) {
      this.message.create('warning', '知识描述不得超过200字!');
      return;
    }
    this.filePathList = [];
    if (this.uploadFileList.length > 0) {
      this.uploadFileList.forEach(element => {
        if (element.response.code === 200) {
          if (this.fileType.some(e => e === element.type)) {
            element.type = 'img';
          } else {
            element.type = 'txt';
          }
          const node = {
            name: element.name,
            url: element.response.data.url,
            type: element.type
          };
          this.filePathList.push(node);
        }
      });
    } else {
      this.filePathList = [];
    }
    if (this.filePathList === null && (this.validateForm.value.desc === null
      || this.validateForm.value.ktNo === undefined || this.validateForm.value.ktNo.toString() === '')) {
      this.message.create('warning', '请填写知识点描述或上传附件!');
      return;
    }
    this.modal.confirm({
      nzTitle: '<i>确认保存当前知识点？</i>',
      // nzContent: '<b>保存？</b>',
      nzOnOk: () => this.saveKnowledgeDataInfo()
    });
  }
  async saveKnowledgeDataInfo() {
    if(this.validateForm == undefined){
      return;
    }
    this.uploading = true;
    let result;
    if (this.kno != null && this.kno !== undefined) {
      // 修改
      result =
        await this.daService.editKnowledge(this.kno, this.validateForm.value, this.filePathList);
    } else {
      // 新增
      result =
        await this.daService.saveKnowledge(this.validateForm.value, this.filePathList);
    }
    this.uploading = false;
    if (result.code !== 200) {
      console.log(result.msg);
      this.message.create('error', result.msg);
    } else {
      this.message.create('success', '保存知识点成功!');
      this.modalRef.destroy('success');
    }
  }

}
class FileNode implements NzUploadFile {
  uid: string ;
  name: string;
  [key: string]: any;
}
